import { SCREEN_SHARE_CAPTURE_OPTIONS } from "../../../engine/live/room/screenShareToggle"
import { supportsScreenSharing } from "@livekit/components-core"
import { useLocalParticipantPermissions, useTrackToggle } from "@livekit/components-react"
import { Track } from "livekit-client"

// Mostly the user closing the browser's share picker
const onDeviceError = (error) => console.warn("Screen share toggle failed:", error)

// Same LiveKit toggle, options and visibility rule as the control bar's
// screen-share button, so the 3-dot menu (narrow window) shares exactly like
// the wide window.
export function useScreenShare() {
    const { toggle, enabled, pending } = useTrackToggle({
        source: Track.Source.ScreenShare,
        captureOptions: SCREEN_SHARE_CAPTURE_OPTIONS,
        onDeviceError,
    })
    const permissions = useLocalParticipantPermissions()

    return {
        isScreenShareEnabled: enabled,
        // No argument forwarded: toggle(x) would force the state to x
        toggleScreenShare: () => toggle(),
        isLoading: pending,
        canScreenShare: supportsScreenSharing() && !!permissions?.canPublish,
    }
}
